import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const Appointment = () => {
  const companyDetail = useSelector((state) => state.companyReducer.company)
  const [companyAddress, setCompanyAddress] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [contactEmail, setContactEmail] = useState("");

  useEffect(() => {
    const companyData = companyDetail;

    if (companyData) {
      // Extract address
      if (companyData.address) {
        const { streetName1, streetName2, city, state, zipcode, country } =
          companyData.address;
        const fullAddress = `${streetName1} ${streetName2}, ${city}, ${state}, ${zipcode}, ${country}`;
        setCompanyAddress(fullAddress);
      }

      // Extract contact phone and email
      if (companyData.contactPerson) {
        setContactPhone(companyData.contactPerson.phoneNumber);
        setContactEmail(companyData.contactPerson.email);
      }
    }
  }, [companyDetail]);

  return (
    <div className="bg-white p-8">
      <div className="text-center mb-8">
        <h1 className="text-blue-900 font-extrabold text-3xl">
          Get in touch
        </h1>
        <h2 className="text-blue-500 font-medium text-lg">
          We want to share our location so you can find us easily and book your appointment!
        </h2>

      </div>

      {/* Contact Details and Calendar */}
      <div className="space-y-6">
        {/* Office Address */}
        <div className="p-4 border rounded-lg shadow-sm w-3/4 md:w-1/2 mx-auto">
          <h3 className="font-bold text-blue-900 mb-2">Office address</h3>
          <p className="text-gray-600">{companyAddress || "Not available"}</p>
        </div>

        {/* Telephone Number */}
        <div className="p-4 border rounded-lg shadow-sm w-3/4 md:w-1/2 mx-auto">
          <h3 className="font-bold text-blue-900 mb-2">Telephone number</h3>
          <p className="text-gray-600">{contactPhone || "Not available"}</p>
        </div>

        {/* Mail Address */}
        <div className="p-4 border rounded-lg shadow-sm w-3/4 md:w-1/2 mx-auto">
          <h3 className="font-bold text-blue-900 mb-2">Mail address</h3>
          <p className="text-gray-600">{contactEmail || "Not available"}</p>
        </div>

        {/* Calendar */}
        <div className="p-6 border rounded-lg shadow-sm w-3/4 md:w-1/2 mx-auto bg-green-50">
          <div className="flex justify-between items-center mb-4">
            <h3 className="font-bold text-green-700">December 2024</h3>
            <button className="text-green-700 font-bold text-lg">→</button>
          </div>
          <div className="grid grid-cols-7 gap-2 text-center">
            {["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"].map((day) => (
              <span key={day} className="font-bold text-green-700">
                {day}
              </span>
            ))}
            {Array.from({ length: 31 }, (_, i) => (
              <div
                key={i + 1}
                className={`p-2 rounded-full ${i + 1 === 9
                    ? "bg-green-500 text-white font-bold"
                    : "text-gray-500"
                  }`}
              >
                {i + 1}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Appointment;
